import * as types from "../types";

export const loadingViewStart = (value) => ({
  type: types.LOADING_VIEW_STATE,
  value,
});

export const funcSaveUserDetails =
  (userDetail, currentScreen, currentAction, callback) => (dispatch) => {
    dispatch({
      type: types.SAVE_PERSONAL_DETAILS,
      payload: userDetail,
    });

    dispatch({
      type: types.UPDATE_CURRENT_APP_STATE,
      payload: {
        isSaved: true,
        currentAction: currentAction,
        //screenName: currentScreen,
        isSubmited: false,
        isSubmitedSuccess: false,
        datafilled: false,
        loading: false,
        error: null,
      },
    });
    if (callback) callback();
  };
export const funcClearValError = (value) => (dispatch) => {
  dispatch({
    type: types.SAVE_VAL_ERROR,
    payload: value,
  });
};

export const funcSaveOnlyUserDetails = (userDetail) => (dispatch) => {
    dispatch({
      type: types.SAVE_PERSONAL_DETAILS,
      payload: userDetail,
    });
  };

export const clearUserData=()=>(dispatch)=>{
 dispatch({type:types.CLEAR_USER_DATA})
 
 dispatch({
  type: types.UPDATE_CURRENT_APP_STATE,
  payload: {
    isSaved: true,
    currentAction: "ValidateOTP",
    screenName: "personalDetails",
    isSubmited: false,
    isSubmitedSuccess: false,
    datafilled: false,
    loading: false,
    error: null,
  },
});
}
export const saveSelectedNwData = (selectedNwData) => (dispatch) => {
  dispatch({type:types.SAVE_SELECTED_NW_DATA,
    payload:
      selectedNwData
    });
}
